// Sorting helpers for the Dashboard "Tiket Terakhir" list.
// Extracted so unit tests can pin the exact ordering rules.

/**
 * Ticket sort key: prefer `tgl_masuk` (canonical "tanggal masuk tiket") and
 * fall back to `created_at` for legacy rows that never had `tgl_masuk` set.
 * Returns a comparable string ("" when both are missing, which sorts last).
 *
 * Both fields are stored as ISO strings ("2026-08-20" for `tgl_masuk`,
 * "2026-08-20T05:12:33.123456+00:00" for `created_at`) so a lexicographic
 * comparison is equivalent to a chronological one for values in the same
 * shape. When we mix a bare date with a full ISO timestamp we still get the
 * correct calendar ordering because both start with `YYYY-MM-DD`.
 */
export function ticketRecencyKey(t) {
  return t?.tgl_masuk || t?.created_at || "";
}

/**
 * Sort a list of tickets from newest → oldest by `ticketRecencyKey`.
 * Non-mutating: returns a new array.
 */
export function sortRecentTicketsDesc(list) {
  return [...(list || [])].sort((a, b) => {
    const ka = ticketRecencyKey(a);
    const kb = ticketRecencyKey(b);
    if (ka === kb) return 0;
    return ka < kb ? 1 : -1;
  });
}
